/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { connect } from "react-redux";
import cookie from "react-cookies";
import "react-datepicker/dist/react-datepicker.css";
import { apiUrl, adminlimit } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "product/listAnalytics";
var moduleName = "Analytics Report";
const clickType = [
  { name: "Click Count", key: "clickCount" },
  { name: "Signin Count", key: "signinCount" },
  { name: "Buy Count", key: "buyCount" },
];
class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      path: this.props?.location?.pathname || '',
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      socialanalytics: [],
      productNameList:[],
      loading: true,
      user: "",
      searchkeywords: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        socialanalytics: nextProps.socialanalytics,
        productNameList:nextProps.productNameList,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";

    if (this.state.searchkeywords !== "") {
      addParams += "&name=" + this.state.searchkeywords;
    }
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        addParams,
      url: apiUrl + module,
      authType: "client",
    };
    this.props.getListData(params);

    
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        searchkeywords: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"analytics"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="searchkeywords"
                        onChange={this.handleChangeText}
                        placeholder="Search Keywords"
                        value={this.state.searchkeywords}
                      />
                      <label htmlFor="name">Search</label>
                    </div>
                  </div>
                  <div className="col-md-4 mt-2">
                    <button
                      type="button"
                      className="btn btn-primary me-sm-3 me-1 waves-effect waves-light"
                      onClick={this.searchList.bind(this)}
                    >
                      Search
                    </button>
                    <button
                      type="reset"
                      className="btn btn-label-secondary waves-effect me-sm-3 me-1"
                      onClick={this.resetSearch.bind(this)}
                    >
                      Reset
                    </button>
                  </div>
                </div>
                <div className="card">
                  <div className="table-responsive text-nowrap p-1 mt-4">
                    <table className="table">
                      <thead>
                        <tr>
                          <th rowSpan={2} valign="middle" style={{width:'250px'}}>
                            Product Name
                          </th>
                          {console.log(this.state.socialanalytics, 'this.state.socialanalytics')}
                          {this.state.socialanalytics.map((item, index) => {
                            return (
                              <th
                                key={index}
                                colSpan={3}
                                className="middlealign"
                              >
                                {item}
                              </th>
                            );
                          })}
                        </tr>
                        <tr>
                      
                          {this.state.socialanalytics.map((item, index) => {
                            return (
                             <React.Fragment key={index}>
                              <th className="middlealign">Click</th>
                              <th className="middlealign">Signin</th>
                              <th className="middlealign">Buy</th>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                        <tr>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={6} align="center">
                              <div
                                className="spinner-border spinner-border-lg text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) :( this.state.productNameList.length > 0 ? (this.state.productNameList.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <strong>{item.productName}</strong>
                              </td>
                              {this.state.socialanalytics.map((aitem, aindex) => {
                                const matchedData = this.state.listdata.find(
                                  listItem =>
                                    listItem.analyticsProductID === item._id &&
                                    listItem.analyticsType === aitem
                                );

                                // Logging (optional)
                                console.log(matchedData, 'matchedData');

                                return matchedData ? (
                                  <React.Fragment key={`${index}-${aindex}`}>
                                    <td>{matchedData.clickCount ?? 0}</td>
                                    <td>{matchedData.signinCount ?? 0}</td>
                                    <td>{matchedData.buyCount ?? 0}</td>
                                  </React.Fragment>
                                ) : (
                                  // Add empty cells if no match found
                                  <React.Fragment key={`${index}-${aindex}`}>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                  </React.Fragment>
                                );
                              })}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={8}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  let listdata = [];
  let listdataStatus = "";
  let totalPages = 0;
  let totalRecords = 0;
  let socialanalytics = [];
  let productNameList = []
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
      socialanalytics = state.listdata[0].analyticsTypeList;
      productNameList = state.listdata[0].productNameList;
      console.log(state.listdata[0].productNameList, 'state.listdata[0].productNameList')
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
    socialanalytics: socialanalytics,
    productNameList:productNameList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
